import React, { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

const FormInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  onKeyUp,
  onKeyDown,
  placeholder,
  error,
  required = false,
  maxLength,
  labelClassName = "",
  divClassName = "",
  inputClassName = "",
  infoMsg = "",
  infoIcon=false
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const inputEl = inputRef?.current;
    if (type === "number" && inputEl) {
      const handleWheel = (e) => inputEl?.blur();
      inputEl?.addEventListener("wheel", handleWheel, { passive: false });
      return () => {
        inputEl?.removeEventListener("wheel", handleWheel);
      };
    }
  }, [type]);

  return (
    <div className="row">
      {label && (
        <div className={labelClassName}>
          <div className="formgroups">
            <h4
              className={
                required
                  ? "label-required font-size d-flex"
                  : "font-size d-flex"
              }
            >
              {label}
              {(infoMsg && infoIcon)&&(
              <div className="toolktis">
                <span className="erroMessagwrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-info-circle-filled"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                      strokeWidth="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
                <div className="tooltpimessae" style={{ width: "162px" }}>
                  {infoMsg}
                </div>
              </div>
              )}
            </h4>
          </div>
        </div>
      )}
      <div className={divClassName}>
        <Form.Group className={`${inputClassName} mb-3`}>
          <Form.Control
          ref={inputRef}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            maxLength={maxLength}
          />
        <div style={{height: "15px"}}>
          {error && (<div className="text-danger">{error}</div>)}
          </div>
        </Form.Group>
      </div>
    </div>
  );
};

export default FormInput;
